import { useState, useEffect } from 'react'
import axios from 'axios';
import { base_url } from '../../../../config';
import BookingConfirmPage from '../../../pages/bookingConfirmPage';
import ShareModal from '../../../shared/shareModal/ShareModal';

const UpcomingTable = ({upcomingBooking}) => {

  const gender = localStorage.getItem("gender");
  const enableGalPal = (gender === 'Female' && upcomingBooking?.table_details?.table_type === 'NO_HOST' && upcomingBooking?.invited_guests?.length == 0) ? true : false;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCancellation, setShowCancellation] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isGalPalModalOpen, setIsGalPalModalOpen] = useState(false);
  const [galPalPhone, setGalPalPhone] = useState('');
  const [galPalName, setGalPalName] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showFullTerms, setShowFullTerms] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [cancellationAvailable, setCancellationAvailable] = useState(isCancellationAvailable(upcomingBooking?.table_details?.event_date));

  const [isInviteGalPalEnabled, setIsInviteGalPalEnabled] = useState(enableGalPal);

  function parseEventDate(dateStr) {
    const [datePart, timePart] = dateStr?.split(' ');
    const [day, month, year] = datePart?.split('-')?.map(Number);
    const [hour, minute] = timePart?.split(':')?.map(Number);
    return new Date(year, month - 1, day, hour, minute);
  }

  function isCancellationAvailable(eventDateStr) {
    const eventDate = parseEventDate(eventDateStr);
    const now = new Date();
    const diffInMs = eventDate.getTime() - now.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours > 24;
  }

  const handleCancellation = async (eventDateStr) => {
    try {
      const isValid = isCancellationAvailable(eventDateStr);
      if (!isValid) {
        setCancellationAvailable(false);
        return;
      }

      const accessToken = localStorage.getItem("@user");
      const userId = localStorage.getItem("@userAccount");
      const url = `${base_url}/table-booking/cancel-booking`;
      
      const body = {
        amount: upcomingBooking?.table_details?.price * 100,
        orderId: upcomingBooking?.order_id,
        tableId: upcomingBooking?.table_details?.id,
        userId: userId
      };
      
      await axios.post(url, body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      });
      
      window.location.reload();
    } catch (error) {
      console.log('Error in handleCancellation :: ', error);
    }
  };

  const handleGalPalInvite = async () => {
    let hasError = false;
    
    if (!galPalName.trim()) {
      setNameError(true);
      hasError = true;
    } else {
      setNameError(false);
    }
    
    if (!galPalPhone.trim()) {
      setPhoneError(true);
      hasError = true;
    } else {
      setPhoneError(false);
    }
    
    if (!acceptedTerms) {
      setTermsError(true);
      hasError = true;
    } else {
      setTermsError(false);
    }
    
    if (hasError) {
      return;
    }
    
    try {
      const accessToken = localStorage.getItem("@user");
      const userId = localStorage.getItem("@userAccount");
      const url = `${base_url}/table-booking/invite-gal-pal`;
      
      const body = {
        name: galPalName,
        countryCode: '+91',
        phoneNumber: galPalPhone,
        orderId: upcomingBooking?.order_id,
        tableId: upcomingBooking?.table_details?.id,
        userId: userId
      };
      
      await axios.post(url, body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      });
      
      setToast({ show: true, message: 'Invitation sent successfully!', type: 'success' });
      setIsGalPalModalOpen(false);
      setGalPalName('');
      setGalPalPhone('');
      setAcceptedTerms(false);
      setShowFullTerms(false);
      setNameError(false);
      setPhoneError(false);
      setTermsError(false);
    } catch (error) {
      console.log('Error in handleGalPalInvite :: ', error);
      setToast({ show: true, message: 'Failed to send invitation. Please try again.', type: 'error' });
    }
  };

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ show: false, message: '', type: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [toast.show]);

       
  // Helper to format event_date string like "22-12-2025 11:00" to "Sun, Dec 22, 2025, 11:00 AM"
  const formatEventDate = (s) => {
    if (!s) return "";
    const [datePart, timePart] = s.split(" ");
    const [dd, mm, yyyy] = datePart.split("-").map((p) => parseInt(p, 10));
    const [hh = 0, min = 0] = (timePart || "").split(":").map((p) => parseInt(p, 10));
    if ([dd, mm, yyyy].some((n) => isNaN(n))) return s;
    const d = new Date(yyyy, mm - 1, dd, hh, min);
    return d.toLocaleString(undefined, {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div>
      <div className="relative  mb-10 flex w-full sm:w-xl flex-col rounded-2xl bg-white bg-clip-border text-gray-700 shadow-md">
        <div className="relative mx-4 -mt-6 h-40 overflow-hidden rounded-xl bg-clip-border text-white  bg-[#f7c900] shadow-xl"></div>
        <img  src={`https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/tables/hd/${upcomingBooking?.table_details?.media}`} alt="Upcoming Event"
          className='sm:w-96 h-32 bg-gray-200 relative mx-6 sm:mx-12 -mt-20 h-48 overflow-hidden rounded-xl bg-blue-gray-500 bg-clip-border'
        />
        <div className="p-6">
          <h5 className="mb-2 block font-sans text-2xl font-semibold leading-snug tracking-normal text-black antialiased">
            {upcomingBooking?.table_details?.title || "Upcoming Event"}
          </h5>
          <p className="block font-sans text-base font-light leading-relaxed text-inherit antialiased">
            {formatEventDate(upcomingBooking?.table_details?.event_date)}
          </p>
        </div>
        <div className="p-6 pt-0 flex gap-3">
          <button onClick={()=>setIsModalOpen(true)}  className="select-none rounded-lg bg-black -500 py-3 px-6 text-center 
            align-middle font-sans text-sm font-bold uppercase text-white shadow-md shadow-blue-500/20 transition-all hover:shadow-lg 
            hover:shadow-blue-500/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
            View Ticket
          </button>
          
          <button 
            className="select-none rounded-lg bg-black -500 py-3 px-6 text-center 
            align-middle font-sans text-sm font-bold uppercase text-white shadow-md shadow-blue-500/20 transition-all hover:shadow-lg 
            hover:shadow-blue-500/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            onClick={() => {
              if (cancellationAvailable) {
                handleCancellation(upcomingBooking?.table_details?.event_date);
              }
            }}
            disabled={!cancellationAvailable}
            style={{ fontSize: '12px', textTransform: 'uppercase' }}
          >
            {cancellationAvailable ? 'Cancel Booking' : 'Cancellation time over!'}
          </button>

          {isInviteGalPalEnabled && <button 
            className="select-none rounded-lg py-3 px-6 text-center 
            align-middle font-sans text-sm font-bold text-black shadow-md shadow-blue-500/20 transition-all hover:shadow-lg 
            hover:shadow-blue-500/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            onClick={() => {
              setIsGalPalModalOpen(true);
            }}
            style={{ fontSize: '12px', backgroundColor: '#f5b3ee' }}
          >
            INVITE YOUR "Gal Pal" FOR FREE
          </button>}

        </div>

        <div >
          <p 
            style={{
              cursor: 'pointer',
              color: 'blue',
              textDecoration: 'underline',
              marginBottom: '10px',
              marginLeft: '22px'
            }}
            onClick={() => setShowCancellation(!showCancellation)}
          >
            * Cancellation Policy click here to know more...
          </p>
          {showCancellation && (
            <div style={{
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              backgroundColor: '#f8f9fa',
              boxShadow: '0 2px 6px rgba(37, 174, 233, 0.2)',
              padding: '16px'
            }}>
              <ul style={{ color: 'black' }}>
                <li>• Cancellations made up to 24 hours before the event: 100% refund (excluding payment transaction fee)</li>
                <li>• Cancellations made within 24 hours of the event: No refund</li>
                <li>• In case the event is cancelled by the host/venue, guests will receive a full refund (including payment transaction fee)</li>
                <li>• No-shows will not be eligible for a refund.</li>
              </ul>
            </div>
          )}
        </div>
      </div>

       {
        isModalOpen &&
        <div className="fixed w-full bg-black/40 z-[999] inset-0">

        <BookingConfirmPage
            data={upcomingBooking?.table_details}
            closeModal={()=>setIsModalOpen(false)}
            userDetails={upcomingBooking?.table_details?.user_profile}
            setIsShareModalOpen={setIsShareModalOpen}
          />
       </div>  
      }
      <ShareModal
            data={upcomingBooking?.table_details}
            setIsModalOpen={setIsShareModalOpen}
            isShareModalOpen={isShareModalOpen}
          />
      
      {isGalPalModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-gray-800">Invite Your Gal Pal</h2>
              <button
                onClick={() => {
                  setIsGalPalModalOpen(false);
                  setGalPalPhone('');
                  setAcceptedTerms(false);
      setShowFullTerms(false);
      setGalPalName('');
      setNameError(false);
      setPhoneError(false);
      setTermsError(false);
                }}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ×
              </button>
            </div>
            
            <div className="mb-4">
              <label htmlFor="galPalName" className="block text-sm font-medium text-gray-700 mb-2">
                Friend's Name
              </label>
              <input
                type="text"
                id="galPalName"
                value={galPalName}
                onChange={(e) => {
                  setGalPalName(e.target.value);
                  if (nameError) setNameError(false);
                }}
                placeholder="Enter your friend's name"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  nameError 
                    ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                    : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                }`}
              />
              {nameError && (
                <p className="mt-1 text-sm text-red-600">Please enter your friend's name</p>
              )}
            </div>
            
            <div className="mb-4">
              <label htmlFor="galPalPhone" className="block text-sm font-medium text-gray-700 mb-2">
                Phone Number
              </label>
              <div className="flex">
                <div className="flex items-center px-3 py-2 border border-r-0 rounded-l-md bg-gray-50 text-gray-700 text-sm">
                  🇮🇳 +91
                </div>
                <input
                  type="tel"
                  id="galPalPhone"
                  value={galPalPhone}
                  onChange={(e) => {
                    setGalPalPhone(e.target.value);
                    if (phoneError) setPhoneError(false);
                  }}
                  placeholder="Enter phone number"
                  className={`flex-1 px-3 py-2 border rounded-r-md focus:outline-none focus:ring-2 ${
                    phoneError 
                      ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                      : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                  }`}
                />
              </div>
              {phoneError && (
                <p className="mt-1 text-sm text-red-600">Please enter a phone number</p>
              )}
            </div>
            
            <div className="mb-4">
              <div className="flex items-start">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  checked={acceptedTerms}
                  onChange={(e) => {
                    setAcceptedTerms(e.target.checked);
                    if (termsError) setTermsError(false);
                  }}
                  className={`mt-1 mr-2 ${termsError ? 'accent-red-500' : ''}`}
                />
                <label htmlFor="acceptTerms" className="text-sm text-gray-600">
                  I agree to the{' '}
                  <span 
                    className="text-blue-600 hover:underline cursor-pointer"
                    onClick={() => setShowFullTerms(!showFullTerms)}
                  >
                    Terms & Conditions
                  </span>{' '}
                  for inviting my gal pal.
                  {showFullTerms && (
                    <div className="mt-2 p-3 bg-gray-50 rounded border text-xs">
                      <ul className="ml-1 list-disc space-y-1">
                        <li>1. The Bring Your +1 coupon is for first-time users only and can be used once per member.</li>
                        <li>2. Enter your coupon code when booking to redeem your free +1 seat.</li>
                        <li>3. Coupons are valid until the date of the table and cannot be combined with other offers.</li>
                        <li>4. The +1 seat is tied to the primary guest's booking.</li>
                        <li>5. Cancellation Policy:
                          <ul className="mt-1">
                            <li>• Cancel at least 24 hours before the event.</li>
                            <li>• If the primary guest cancels, the +1 is also canceled.</li>
                          </ul>
                        </li>
                        <li>6. HighTable may reschedule or cancel events; registered guests will be notified.</li>
                        <li>7. Misuse of the coupon voids the offer.</li>
                      </ul>
                    </div>
                  )}
                </label>
              </div>
              {termsError && (
                <p className="mt-1 text-sm text-red-600">Please accept the terms and conditions</p>
              )}
            </div>
            
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setIsGalPalModalOpen(false);
                  setGalPalPhone('');
                  setAcceptedTerms(false);
      setShowFullTerms(false);
      setGalPalName('');
      setNameError(false);
      setPhoneError(false);
      setTermsError(false);
                }}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleGalPalInvite}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                style={{ backgroundColor: '#e2b761' }}
              >
                Send Invite
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Toast Notification */}
      {toast.show && (
        <div className="fixed top-4 right-4 z-50 animate-slide-in">
          <div className={`px-4 py-3 rounded-lg shadow-lg text-white ${
            toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'
          }`}>
            <div className="flex items-center justify-between">
              <span>{toast.message}</span>
              <button
                onClick={() => setToast({ show: false, message: '', type: '' })}
                className="ml-3 text-white hover:text-gray-200"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default UpcomingTable
